import React, { type ReactNode } from "react";
import type { Option } from "src/components/SelectV2/SelectV2.types.ts";

import { MultiplePreview } from "src/components/SelectV2/MultiplePreview.tsx";
import { SinglePreview } from "src/components/SelectV2/SinglePreview.tsx";
import { ButtonPreview } from "src/components/SelectV2/ButtonPreview.tsx";

type PreviewProps<Value = unknown> = {
  disabled: boolean;
  isLoadingData: boolean;
  isLoadingSelectedOption: boolean;
  flatOptions: Option<Value>[];
  placeholder?: ReactNode;
  isMultiple: boolean;
  value: Value[] | Value | "";
  onValueChange: (value: Value[] | Value | "") => void;
  fallbackOptions: Option<NoInfer<Value>>[];
  truncateOptions?: boolean;
  isButton: boolean;
  isOpen: boolean;
};

export const Preview = <Value = unknown,>({
  disabled,
  isLoadingData,
  isLoadingSelectedOption,
  placeholder,
  flatOptions,
  value,
  isMultiple,
  onValueChange,
  fallbackOptions,
  truncateOptions,
  isButton,
  isOpen,
}: PreviewProps<Value>) => {
  if (isButton) {
    return (
      <ButtonPreview
        value={value as Value | ""}
        disabled={disabled}
        isLoadingData={isLoadingData}
        flatOptions={flatOptions}
        isLoadingSelectedOption={isLoadingSelectedOption}
        placeholder={placeholder}
        fallbackOptions={fallbackOptions}
        isOpen={isOpen}
      />
    );
  }
  if (isMultiple) {
    return (
      <MultiplePreview<Value>
        value={value as Value[] | ""}
        onValueChange={onValueChange}
        flatOptions={flatOptions}
        isLoadingData={isLoadingData}
        disabled={disabled}
        isLoadingSelectedOption={isLoadingSelectedOption}
        placeholder={placeholder}
        fallbackOptions={fallbackOptions}
        truncateOptions={truncateOptions}
      />
    );
  }
  return (
    <SinglePreview<Value>
      value={value as Value | ""}
      disabled={disabled}
      isLoadingData={isLoadingData}
      flatOptions={flatOptions}
      isLoadingSelectedOption={isLoadingSelectedOption}
      placeholder={placeholder}
      fallbackOptions={fallbackOptions}
    />
  );
};
